import type { Id } from '@e-socna/data-layer';

import type { GlobalTotalOptionsSection } from '../../../components/ServiceUsages/utils/global-total-option-items.util';

import { COLLABORATION_SERVICES_LABEL } from '../constants/collaboration-pricing.constant';

import { buildSubMissionShortLabels } from './sub-mission-short-label.util';
import type { SubMissionSnapshotSection } from './split-snapshot-groups-by-sub-mission.util';

type SnapshotGroup = Readonly<{ _id: Id }>;

type LabelledSubMission = Readonly<{
  _id: Id;
  code: string;
  typeCode?: string | null;
}>;

// The option checkboxes of a frozen collaboration, nested like the live ones:
// one section per sub-mission of its quotation, then its own groups.
export const buildFrozenTotalSections = ({
  collaborationId,
  ownGroups,
  subMissionSections,
  subMissions,
}: Readonly<{
  collaborationId: Id;
  ownGroups: readonly SnapshotGroup[];
  subMissionSections: readonly SubMissionSnapshotSection<SnapshotGroup>[];
  subMissions: readonly LabelledSubMission[];
}>): readonly GlobalTotalOptionsSection[] => {
  const pricedSections = subMissionSections.flatMap((section) => {
    const subMission = subMissions.find(
      ({ _id }) => _id === section.subMissionId,
    );

    return subMission ? [{ section, subMission }] : [];
  });
  const shortLabels = buildSubMissionShortLabels(
    pricedSections.map(({ subMission }) => subMission),
  );

  return [
    ...pricedSections.map(({ section }, index): GlobalTotalOptionsSection => ({
      _id: section.subMissionId,
      label: shortLabels[index] ?? '',
      groupIds: section.groups.map((group) => group._id),
    })),
    {
      _id: collaborationId,
      label: COLLABORATION_SERVICES_LABEL,
      groupIds: ownGroups.map((group) => group._id),
    },
  ];
};
